export const INITIAL_ZOOM_LEVEL = 15;
